/**
 * Lazy loaded components
 *
 * We want to minimized the size of the JS delivered to the client
 * Every component that:
 * 1) has a substantial set of conditional child components
 * 2) it's very big (should implement point 1)
 *
 * will need to use dynamic imports
 * If the sub components is shared among other components then it needs to
 * be put here and imported
 */

import { defineAsyncComponent } from 'vue';

// Pages
export const HomePage = () => import('@/pages/home/HomePage.vue');
export const New = () => import('@/pages/New.vue');
export const Upcoming = () => import('@/pages/Upcoming.vue');
export const PlotRecommender = () => import('@/pages/landing-pages/plot-recommender/PlotRecommender.vue');
export const Popular = () => import('@/pages/Popular.vue');
export const RefreshToken = () => import('@/pages/RefreshToken.vue');
export const Search = () => import('@/pages/Search.vue');
export const StaticPage = () => import('@/pages/StaticPage.vue');
export const StreamGreen = () => import('@/pages/landing-pages/stream-green/StreamGreen.vue');
export const SubscriberForm = () => import('@/pages/landing-pages/subscriber-form/SubscriberForm.vue');
export const Talent = () => import('@/pages/Talent.vue');
export const TitleDetail = () => import('@/pages/TitleDetail.vue');

export const TvRegistration = () => import('@/pages/TvRegistration.vue');

export const Watchlist = () => import('@/pages/Watchlist.vue');
export const CollegesMostSuperBowlPlayers = () =>
	import('@/pages/landing-pages/sports/CollegesMostSuperBowlPlayers.vue');
export const ExpansionSeasonsMLS = () => import('@/pages/landing-pages/sports/ExpansionSeasonsMLS.vue');
export const NBAPlayoffs = () => import('@/pages/landing-pages/sports/NBAPlayoffs.vue');
export const StreamingCharts = () => import('@/pages/landing-pages/streaming-charts/StreamingCharts.vue');

export const StatisticPage = () => import('@/pages/landing-pages/statistics/StatisticPage.vue');
export const GlobalPress = () => import('@/pages/landing-pages/global-press/GlobalPress.vue');
export const APNews = () => import('@/pages/landing-pages/ap-news/APNews.vue');
export const PressRelease = () => import('@/pages/PressRelease.vue');

// Title List
export const TitleList = defineAsyncComponent(() => import('@/components/list/TitleList.vue'));

// Modals
export const AccountModal = defineAsyncComponent(() => import('@/components/modals/account/AccountModal.vue'));
export const LoginManager = defineAsyncComponent(() => import('@/components/login-manager/LoginManager.vue'));
export const CountrySelectionModal = defineAsyncComponent(
	() => import('@/components/mobile/CountrySelectionModal.vue')
);
export const ProModal = defineAsyncComponent(() => import('@/components/modals/pro/ProModal.vue'));

export const CancelProModal = defineAsyncComponent(() => import('@/components/modals/pro/CancelProModal.vue'));
export const LanguageSelectionModal = defineAsyncComponent(
	() => import('@/components/mobile/LanguageSelectionModal.vue')
);
export const LoginMessageModal = defineAsyncComponent(() => import('@/components/modals/login/LoginMessageModal.vue'));
export const PackagesSelectionModal = defineAsyncComponent(
	() => import('@/components/modals/package-selection/PackagesSelectionModal.vue')
);
export const FilterProductionCountryMoreModal = defineAsyncComponent(
	() => import('@/components/modals/FilterProductionCountryMoreModal.vue')
);

export const SettingsModal = defineAsyncComponent(() => import('@/components/modals/SettingsModal.vue'));
export const CountryList = defineAsyncComponent(() => import('@/components/modals/country-list/CountryList.vue'));
export const LanguageList = defineAsyncComponent(
	() => import('@/components/modals/account/language-list/LanguageList.vue')
);
export const TextRecommendationModalV2 = defineAsyncComponent(
	() => import('@/features/why-to-watch/components/TextRecommendationModalV2.vue')
);
export const TextRecommendationCardTitleDetailModal = defineAsyncComponent(
	() => import('@/features/why-to-watch/components/TextRecommendationCardTitleDetailModal.vue')
);

// Components
export const FilterBar = defineAsyncComponent(() => import('@/components/filter-bar/FilterBar.vue'));
export const YoutubePlayer = defineAsyncComponent(() => import('@/ui-components/YoutubePlayer.vue'));
export const VideoJsPlayer = defineAsyncComponent(() => import('@/ui-components/players/VideoJsPlayer.vue'));
export const TrailerModal = defineAsyncComponent(() => import('@/components/TrailerModal.vue'));

// Filters
export const FilterProductionCountry = defineAsyncComponent(
	() => import('@/components/filter-bar/FilterProductionCountry.vue')
);
export const FilterRuntime = defineAsyncComponent(() => import('@/components/filter-bar/FilterRuntime.vue'));
export const FilterVoteCount = defineAsyncComponent(() => import('@/components/filter-bar/FilterVoteCount.vue'));

export const UserProfile = defineAsyncComponent(() => import('@/pages/UserProfile.vue'));
export const RentSignin = () => import('@/pages/RentSignin.vue');
export const MarkAsSeenModalContainer = defineAsyncComponent(
	() => import('@/components/mark-as-seen/MarkAsSeenModalContainer.vue')
);

export const JWTVLP = () => import('@/pages/landing-pages/jwtv/JWTVLP.vue');
